<template>
  <div class="p-lg pb-leftSquiggleHeight">
    <h1>Orderable List</h1>
    <div class="p-base mb-xl bg-signableBrandColours-white">
      <h2>GrabHandle component</h2>
      <GrabHandleControl />
    </div>
    <div class="p-base mb-xl bg-signableBrandColours-white flex flex-col gap-base">
      <h2>ChevronControls component</h2>
      <h3>Regular</h3>
      <ChevronControls />
      <h3>Slimline</h3>
      <div class="flex items-start"><ChevronControls slimline /></div>
    </div>
    <div class="p-base mb-xl bg-signableBrandColours-white flex flex-col gap-base">
      <h2>Lists can take any kind of item</h2>
      <h3>List with short items - use default controls</h3>
      <OrderableList
        v-model="shortItemList"
        class="mb-xl"
      >
        <template v-slot:default="{ item }">
          <div class="flex items-center justify-center h-base sm:w-appHeaderLeftFullW p-sm rounded text-signableBrandColours-white bg-signableBrandColours-black">{{ item.name }}</div>
        </template>
      </OrderableList>
      <h3>List with tall items - use slimline controls</h3>
      <OrderableList
        v-model="tallItemList"
        slimlineControls
      >
        <template v-slot:default="{ item }">
          <div class="flex items-center justify-center h-leftSquiggleHeight sm:w-appHeaderLeftFullW p-sm rounded text-signableBrandColours-white bg-signableBrandColours-black">{{ item.name }}</div>
        </template>
      </OrderableList>
    </div>
    <div class="p-base mb-xl bg-signableBrandColours-white mb-screen">
      <h2>List with items that can be added or removed</h2>
      <div>
        <span>Top 3: </span>
        <span>{{ productTeamList[0].name }}, </span>
        <span>{{ productTeamList[1].name }}, </span>
        <span>{{ productTeamList[2].name }}</span>
      </div>
      <div class="my-base flex gap-base">
        <input
          v-model="newListItem"
          type="text"
        />
        <BaseButton
          @click.native="add"
          :disabled="!newListItem"
        >
          Add
        </BaseButton>
      </div>
      <OrderableList v-model="productTeamList">
        <template v-slot:default="{ item }">
          <DismissibleInfoPill
            @dismiss="remove"
            :text="item.name"
            :id="item.id"
            ec="orderable_list_design_page"
          />
        </template>
      </OrderableList>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

import { GrabHandleControl } from '@/components/library/controls/GrabHandleControl';
import { DismissibleInfoPill } from '@/components/library/pills/DismissibleInfoPill';
import { OrderableList } from '@/components/library/lists/orderableList/OrderableList';
import { ChevronControls } from '@/components/library/controls/ChevronControls';
import BaseButton from '@/components/library/buttons/BaseButton.vue';

const newListItem = ref(null);
const tallItemList = ref([{ id: '1tall', name: 'tall item 1' }, { id: '2tall', name: 'tall item 2' }, { id: '3tall', name: 'tall item 3' }]);
const shortItemList = ref([{ id: '1short', name: 'short item 1' }, { id: '2short', name: 'short item 2' }, { id: '3short', name: 'short item 3' }]);
const productTeamList = ref([{ id: '1', name: 'Laura' }, { id: '2', name: 'Laurence' }, { id: '3', name: 'Rich' }, { id: '4', name: 'Aled' }, { id: '5', name: 'Karen' }, { id: '6', name: 'Emily' }, { id: '7', name: 'Abdul' }, { id: '8', name: 'Tom' }, { id: '9', name: 'Nic' }, { id: '10', name: 'Sam' }, { id: '11', name: 'Mukesh' }, { id: '12', name: 'Lee' }, { id: '13', name: 'Max' }]);

function remove(id) {
  const index = productTeamList.value.findIndex(item => item.id === id);
  productTeamList.value.splice(index, 1);
}

function add() {
  if (newListItem.value) {
    const randomId = Math.floor(Math.random() * 100);
    productTeamList.value.splice(0, 0, { id: newListItem.value + randomId, name: newListItem.value });
    newListItem.value = null;
  }
}
</script>

